export { FiltersMetadata as default };

/**
* Filters Metadata Entity
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class FiltersMetadata {
  /**
   * Filters Metadata conditions
   *
   * @public
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  conditions = {};

  /**
   * Filters Metadata Flags
   *
   * @public
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  flags = {};

  /**
   * Filters Metadata actions
   *
   * @public
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  actions = {};

  /**
   * Filters Metadata combine
   *
   * @public
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  combine = {};


  /**
   * Returns the default metadata condition value
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {FiltersItemCondition}
   */
  getDefaultCondition() {
    return this.conditions.values[this.conditions.default];
  }

  /**
   * Returns the default metadata action value
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {String}
   */
  getDefaultAction(){
    return this.actions.default;
  }

  /**
   * Returns the default metadata combine value
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Number}
   */
  getDefaultCombine(){
    return this.combine.default;
  }

  /**
   * Returns condition values ​​in Array format
   *
   * @public
   *
   * @since 7.0.0
   *
   * @returns {Array}
   */
  getConditionsKeys(){
    if(!this.conditions){
      return []
    };

    return Object.keys(this.conditions.values);
  }

}